import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Button, Form, FormGroup, Label, Input, Alert, FormFeedback } from 'reactstrap';
import classnames from 'classnames';

import DateTime from 'react-datetime';
import moment from 'moment';

import { ButtonWithLoader } from '../../../core';

import { statesList } from '../../helpers/states_list';

import { residentDetailsList } from '../../helpers/resident_details';
import { addressProof } from '../../helpers/address_proof';
import { countryCodes } from '../../../core/helpers/country-codes';
import { utils } from '../../../core/helpers/utils';


class ResidenceDetailsForm extends Component {
  constructor(props) {
    super(props);

    if(props && props.data) {
      this.state = {
        errors: {},
        ...props.data
      }
    } else {
      this.state = {
        errors: {}
      };
    }

    this.submitResidenceDetails = this.submitResidenceDetails.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps && nextProps.data) {
      this.setState({
        ...nextProps.data
      })
    }
  }

  componentDidMount() {
    this.setState({
      ...this.props.data
    })
  }
  
  UNSAFE_componentWillMount() {
    this.setState(this.props.data);
  }

  changeResidentStatus(residentStatus) {
    this.setState({
        residentialStatus: residentStatus,
        showPermanentDetailsForm: (residentStatus !== 'Indian Resident')
      });
  }

  submitResidenceDetails(e) {
    e.preventDefault();
    
    this.submit(false);
  }

  submit(shouldMoveNext) {
    this.setState({
      submitting: true
    });
    let address1 = this.state.address1 && this.state.address1.trim();
    let address2  = this.state.address2 && this.state.address2.trim();
    let addressProof = this.state.addressProof && this.state.addressProof.trim();
    let city = this.state.city && this.state.city.trim();
    let  pincode = this.state.pincode && this.state.pincode.trim();
    let _state = this.state.state && this.state.state.trim();
    let country = this.state.country && this.state.country.trim();
    let indianTaxRes = this.state.indianTaxRes && this.state.indianTaxRes.trim();
    let residentialStatus = this.state.residentialStatus && this.state.residentialStatus.trim();

    if ( !address1 || !address2
        || !addressProof || !city
        || !pincode || !_state
        || !country || !indianTaxRes
        || !residentialStatus || this.state.showPermanentDetailsForm
    ) {
      let errors = {};

      if (!address1) {
          errors['address1'] = "please enter your address"
      }
      if (!address2) {
        errors['address2'] = "please enter your address"
      }
      if (!addressProof) {
        errors['addressProof'] = "please select your address proof"
      }
      if (!city) {
        errors['city'] = "please enter your city"
      }
      if (!pincode) {
        errors['pincode'] = "please enter your pincode"
      }
      if (!_state) {
        errors['state'] = "please select your state"
      }
      if (!country) {
        errors['country'] = "please select your country"
      }
      if (!indianTaxRes) {
        errors['indianTaxRes'] = "please select your Indian resitantial tax status"
      }
      if (!residentialStatus) {
        errors['residentialStatus'] = "please select your residential status"
      }
      if (this.state.showPermanentDetailsForm) {
        let perAddress1 = this.state.perAddress1 && this.state.perAddress1.trim();
        let perAddress2 = this.state.perAddress2 && this.state.perAddress2.trim();
        let perAddressProof = this.state.perAddressProof && this.state.perAddressProof.trim();
        let perCity = this.state.perCity && this.state.perCity.trim();
        let perCountry = this.state.perCountry && this.state.perCountry.trim();
        let perState = this.state.perState && this.state.perState.trim();
        let perPincode = this.state.perPincode && this.state.perPincode.trim();

        if (!perAddress1 || !perAddress2 || !perAddressProof || !perCity
            || !perCountry || !perState || !perPincode
        ) {

            if (!perAddress1) {
              errors['perAddress1'] = "please enter your permanent address"
            }
            if (!perAddress2) {
              errors['perAddress2'] = "please enter your permanent address"
            }
            if (!perAddressProof) {
              errors['perAddressProof'] = "please select your permanent address proof"
            }
            if (!perCity) {
              errors['perCity'] = "please enter your permanent city"
            }
            if (!perCountry) {
              errors['perCountry'] = "please select your permanent country"
            }
            if (!perState) {
              errors['perState'] = "please select your permanent state"
            }
            if (!perPincode) {
              errors['perPincode'] = "please enter your pincode"
            }
            this.setState({
              errors: errors,
              submitting: false
            })
        } 
        else {
          if(!this.validate()) {
            return;
          }
          this.residance(shouldMoveNext);
        } 
      }    
      this.setState({
        errors: errors,
        submitting: false
      })
    }
    else {
      if(!this.validate()) {
        return;
      }
      this.residance(shouldMoveNext);
    }
  }

  validate = () =>  {
    let valid = true;
    var errors = {};
    if (!utils.isNumber(this.state.pincode)) {
      errors["pincode"] = "Pin code should be a number";
      valid = false
    } else if (this.state.pincode.length !== 6) {
      errors["pincode"] = "Pin code should be 6 characters only";
      valid = false
    } 
    if (this.state.showPermanentDetailsForm) {
      if (!utils.isNumber(this.state.perPincode)) {
        errors["perPincode"] = "Permanant Pin code should be a number";
        valid = false
      } else if (this.state.perPincode.length !== 6) {
        errors["perPincode"] = "Pin code should be 6 characters only";
        valid = false
      }
    }
    this.setState({
      errors: errors,
      submitting: false
    });
    return valid; 
  }

  residance = (shouldMoveNext) => {
      var residence = {
        address1: this.state.address1,
        address2: this.state.address2,
        address3: "",
        addressProof: this.state.addressProof,
        city: this.state.city,
        pincode: this.state.pincode,
        state: this.state.state,
        country: this.state.country,
        indianTaxRes: this.state.indianTaxRes,
        residentialStatus: this.state.residentialStatus,
        "perAddress1": this.state.perAddress1 ? this.state.perAddress1 : " ",
        "perAddress2": this.state.perAddress2 ? this.state.perAddress2 : " ",
        "perAddress3": "",
        "perAddressProof": this.state.perAddressProof ? this.state.perAddressProof : "",
        "perCity": this.state.perCity ? this.state.perCity : "",
        "perCountry": this.state.perCountry ? this.state.perCountry : " ",
        "perState": this.state.perState ? this.state.perState : " ",
        "perPincode": this.state.perPincode ? this.state.perPincode : " ",
        showPermanentDetailsForm: this.state.showPermanentDetailsForm
      }
  
      this.props.submit('residence', residence, shouldMoveNext);
  
      this.setState({
        errors: {},
        submitting: false
      });
  }

  render() {
    return (
      <Form className="login-form" onSubmit={this.submitResidenceDetails}>
        <FormGroup>
          <Label for="address1" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.address1 })} >
                  Mailing Address Line 1
          </Label>

          <Input type="text" 
                 name="address1" 
                 id="address1" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Mailing Address Line 1" 
                 onChange={e => this.setState({address1: e.target.value})}
                 value={this.state.address1}
                 invalid={this.state.errors.address1}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.address1 || this.state.errors.address1.length === 0) })}>
            {this.state.errors.address1}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="address2" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.address2 })} >
                  Mailing Address Line 2
          </Label>

          <Input type="text" 
                 name="address2" 
                 id="address2" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Mailing Address Line 2" 
                 onChange={e => this.setState({address2: e.target.value})}
                 value={this.state.address2}
                 invalid={this.state.errors.address2}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.address2 || this.state.errors.address2.length === 0) })}>
            {this.state.errors.address2}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="city" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.city })} >
                  City
          </Label>

          <Input type="text" 
                 name="city" 
                 id="city" 
                 className="form-control font-weight-semi-bold"
                 placeholder="City" 
                 onChange={e => this.setState({city: e.target.value})}
                 value={this.state.city}
                 invalid={this.state.errors.city}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.city || this.state.errors.city.length === 0) })}>
            {this.state.errors.city}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="pincode" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.pincode })} >
                  Pincode
          </Label>

          <Input type="text" 
                 name="pincode" 
                 id="pincode" 
                 className="form-control font-weight-semi-bold"
                 placeholder="Pincode" 
                 onChange={e => this.setState({pincode: e.target.value})}
                 value={this.state.pincode}
                 invalid={this.state.errors.pincode}
                 />
          <FormFeedback className={classnames({ invisible: (!this.state.errors.pincode || this.state.errors.pincode.length === 0) })}>
            {this.state.errors.pincode}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="state" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.state })} >
                  State
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="state" 
                  name="state" 
                  value={this.state.state} 
                  onChange={e => this.setState({state: e.target.value})}
                  >
                    <option value="" key="none">State</option>
                    {
                      statesList.map(state => (
                        <option value={state.name} key={state.name}>{state.name}</option> 
                      ))
                    } 
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.state || this.state.errors.state.length === 0) })}>
            {this.state.errors.state}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="Country" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.country })} >
                  Country
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="country" 
                  name="country" 
                  value={this.state.country} 
                  onChange={e => this.setState({country: e.target.value})}
                  >
                    <option value="" key="none">Country</option>
                    {countryCodes.map(country => (
                        <option value={country.name} key={country.name}>{country.name}</option> 
                      ))} 
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.country || this.state.errors.country.length === 0) })}>
            {this.state.errors.country}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="itr" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.indianTaxRes })} >
                  Indian Tax Resident
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="itr" 
                  name="itr" 
                  value={this.state.indianTaxRes} 
                  onChange={e => this.setState({indianTaxRes: e.target.value})}
                  >
                    <option value="" key="none">Indian Tax Resident</option>
                    <option value="yes" key="yes">Yes</option>
                    <option value="no" key="no">No</option>
                    
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.indianTaxRes || this.state.errors.indianTaxRes.length === 0) })}>
            {this.state.errors.indianTaxRes}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="residentStatus" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.residentialStatus })} >
                  Resident Status
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="residentStatus" 
                  name="residentStatus" 
                  value={this.state.residentialStatus} 
                  onChange={e => this.changeResidentStatus(e.target.value)}
                  >
                    <option value="" key="none">Resident Status</option>
                    {residentDetailsList.map(itr => (
                        <option value={itr.name} key={itr.name}>{itr.name}</option> 
                      ))} 
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.residentialStatus || this.state.errors.residentialStatus.length === 0) })}>
            {this.state.errors.residentialStatus}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="addressProof" 
                  className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.addressProof })} >
                  Address Proof
          </Label>

          <select className="custom-select border-bottom border-1 form-control" 
                  id="addressProof" 
                  name="addressProof" 
                  value={this.state.addressProof} 
                  onChange={e => this.setState({addressProof: e.target.value})}
                  >
                    <option value="" key="none">Address Proof</option>
                    {addressProof.map(itr => (
                        <option value={itr.name} key={itr.name}>{itr.name}</option> 
                      ))} 
                  </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.addressProof || this.state.errors.addressProof.length === 0) })}>
            {this.state.errors.addressProof}
          </FormFeedback>
        </FormGroup>

        {
          this.state.showPermanentDetailsForm ? (
            <div>
              <FormGroup>
                <Label for="perAddress1" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perAddress1 })} >
                        Permanent Address Line 1
                </Label>

                <Input type="text" 
                       name="perAddress1" 
                       id="perAddress1" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Permanent Address Line 1" 
                       onChange={e => this.setState({perAddress1: e.target.value})}
                       value={this.state.perAddress1}
                       invalid={this.state.errors.perAddress1}
                       />
                <FormFeedback className={classnames({ invisible: (!this.state.errors.perAddress1 || this.state.errors.perAddress1.length === 0) })}>
                  {this.state.errors.perAddress1}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perAddress2" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perAddress2 })} >
                        Permanent Address Line 2
                </Label>

                <Input type="text" 
                       name="perAddress2" 
                       id="perAddress2" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Permanent Address Line 2" 
                       onChange={e => this.setState({perAddress2: e.target.value})}
                       value={this.state.perAddress2}
                       invalid={this.state.errors.perAddress2}
                       />
                <FormFeedback className={classnames({ invisible: (!this.state.errors.perAddress2 || this.state.errors.perAddress2.length === 0) })}>
                  {this.state.errors.perAddress2}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perCity" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perCity })} >
                        Permanent City
                </Label>

                <Input type="text" 
                       name="perCity" 
                       id="perCity" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Permanent City" 
                       onChange={e => this.setState({perCity: e.target.value})}
                       value={this.state.perCity}
                       invalid={this.state.errors.perCity}
                       />
                <FormFeedback className={classnames({ invisible: (!this.state.errors.perCity || this.state.errors.perCity.length === 0) })}>
                  {this.state.errors.perCity}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perPincode" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perPincode })} >
                        Permanent Pincode
                </Label>

                <Input type="text" 
                       name="perPincode" 
                       id="perPincode" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Permanent Pincode" 
                       onChange={e => this.setState({perPincode: e.target.value})}
                       value={this.state.perPincode}
                       invalid={this.state.errors.perPincode}
                       />
                <FormFeedback className={classnames({ invisible: (!this.state.errors.perPincode || this.state.errors.perPincode.length === 0) })}>
                  {this.state.errors.perPincode}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perState" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perState })} >
                        Permanent State
                </Label>

                <Input type="text" 
                       name="perState" 
                       id="perState" 
                       className="form-control font-weight-semi-bold"
                       placeholder="Permanent State" 
                       onChange={e => this.setState({perState: e.target.value})}
                       value={this.state.perState}
                       invalid={this.state.errors.perState}
                       />
                <FormFeedback className={classnames({ invisible: (!this.state.errors.perState || this.state.errors.perState.length === 0) })}>
                  {this.state.errors.perState}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perCountry" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perCountry })} >
                        Permanent Country
                </Label>

                <select className="custom-select border-bottom border-1 form-control" 
                        id="perCountry" 
                        name="perCountry" 
                        value={this.state.perCountry} 
                        onChange={e => this.setState({perCountry: e.target.value})}
                        >
                          <option value="" key="none">Permanent Country</option>
                          {countryCodes.map(country => (
                              <option value={country.name} key={country.name}>{country.name}</option> 
                            ))} 
                        </select>
                <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.perCountry || this.state.errors.perCountry.length === 0) })}>
                  {this.state.errors.perCountry}
                </FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="perAddressProof" 
                        className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.perAddressProof })} >
                        Permanent Address Proof
                </Label>

                <select className="custom-select border-bottom border-1 form-control" 
                        id="perAddressProof" 
                        name="perAddressProof" 
                        value={this.state.perAddressProof} 
                        onChange={e => this.setState({perAddressProof: e.target.value})}
                        >
                          <option value="" key="none">Permanent Address Proof</option>
                          {addressProof.map(itr => (
                              <option value={itr.name} key={itr.name}>{itr.name}</option> 
                            ))} 
                        </select>
                <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.perAddressProof || this.state.errors.perAddressProof.length === 0) })}>
                  {this.state.errors.perAddressProof}
                </FormFeedback>
              </FormGroup>
            </div>
           ) : ''
        }

        <FormGroup className="cta-block">
          {/* <ButtonWithLoader 
                text="Save" 
                isLoading={this.state.submitting} 
                color="primary" 
                className="w-100 mb-3"
                /> */}

          <ButtonWithLoader 
                text="Next" 
                isLoading={this.state.submitting} 
                className="w-100 btn-outline-dark"
                onClick={() => this.submit(true)}
                />
        </FormGroup>
      </Form>  
    );
  }
}

export default ResidenceDetailsForm; 